import { useEffect, useState } from "react";
import CardSeplag from "../../components/CardSeplag";
import TableSeplag from "../../components/TableSeplag";
import { pesquisarLista, excluirEmpresa, buscaPersonalizada } from "../../service/empresa";
import ModalCadastro from "./ModalCadastro";

import { printToast, detailExclusaoSucessoPadrao, summaryExclusaoSucessoPadrao } from "../../config/global";

import usePermissions from "../../hooks/usePermissions";
import RotuloSeplag from "../../components/RotuloSeplag";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
// import { set } from "date-fns/esm";

const ManterEmpresa = () => {

  // const arrayPermission = usePermissions({ nomeTela: 'MANTEREMPRESA' })

  const [ListaEmpresa, setListaEmpresa] = useState([]);
  const [visible, setVisible] = useState(false);
  const [empresaSelected, setEmpresaSelected] = useState();
  const [nomeFiltro, setNomeFiltro] = useState('');


  useEffect(() => {
    pesquisarLista().then((res) => {
      setListaEmpresa(res.content);
    });
  }, []);

  const onSalvar = () => {
    pesquisarLista().then((res) => {
      setListaEmpresa(res.content);
    });
  };

  const handleShowModalAdicionarEmpresa = () => {
    setVisible(true);
  };

  const handleSearch = async (e) => {
    e.preventDefault()

    const rowData = nomeFiltro !== '' ? await buscaPersonalizada(nomeFiltro) : await pesquisarLista()

    setListaEmpresa(rowData.content)
  };

  function handleShowModalEditarTipoCertidao(rowData) {
    setEmpresaSelected(rowData);
    setVisible(true);
  }

  function handleDelete(parmDelete) {
    excluirEmpresa(parmDelete.idenEmpresa).then(() => {
      let summary = summaryExclusaoSucessoPadrao;
      let detail = detailExclusaoSucessoPadrao;
      printToast({ summary, detail });

      let listaNew = ListaEmpresa.filter((element) => element.idenEmpresa !== parmDelete.idenEmpresa);
      setListaEmpresa(listaNew);
    });
  }

  const camposTabela = [
    { nome: "nomeFantasia", titulo: "Nome Fantasia" },
    { nome: "cnpj", titulo: "CNPJ" },
    { nome: "descInscEstadual", titulo: "Inscrição Estadual" },
  ];

  return (
    <CardSeplag title="Pessoa Jurídica">

      <form onSubmit={handleSearch} className="p-col-12 p-grid">
        <div className="p-col p-grid">

          <RotuloSeplag nome="Pessoa Jurídica" cols="12 3">
            <InputText name="numrCodigo" style={{ width: "100%" }} onChange={(e) => setNomeFiltro(e.target.value)} value={nomeFiltro} />
          </RotuloSeplag>

          <RotuloSeplag cols="12 4">
            <div className="p-col-12 p-md-4" style={{ marginTop: "20px", alignContent: "center" }}>
              <Button label="Filtrar" icon="pi pi-search" className="p-button-raised" type='submit' style={{ marginRight: "5px", width: "10rem" }} />
            </div>
          </RotuloSeplag>
        </div>
      </form>

      <TableSeplag
        dados={ListaEmpresa}
        camposTabela={camposTabela}
        searchPlaceholder="Pesquisar Pessoa Jurídica"
        //onSearch={handleSearch}
        hasEventoAcao
        onAdicionarDado={handleShowModalAdicionarEmpresa}
        onEditarDado={handleShowModalEditarTipoCertidao}
        onExcluirDado={handleDelete}
      />
      {visible && <ModalCadastro visible={visible} setVisible={setVisible} onSalvar={onSalvar} empresa={empresaSelected} />}
    </CardSeplag>
  );
};
export default ManterEmpresa;
